import type { SearchInternshipRefinementType } from './searchInternshipRefinementTypes';
import { SEARCH_INTERNSHIP_REFINEMENT_TYPES } from './searchInternshipRefinementTypes';
import type { SearchJobsRefinementType } from './searchJobsRefinementTypes';
import { SEARCH_JOBS_REFINEMENT_TYPES } from './searchJobsRefinementTypes';

export type SearchRefinementType =
  | SearchJobsRefinementType
  | SearchInternshipRefinementType;

export const SEARCH_REFINEMENT_TYPES = {
  JOB: SEARCH_JOBS_REFINEMENT_TYPES,
  INTERNSHIP: SEARCH_INTERNSHIP_REFINEMENT_TYPES,
  VOLOP: ['TODO'],
  EVENT: ['TODO'],
  ORG: ['TODO'],
} as const;
